import { render, staticRenderFns } from "./PortalInvitationPopup.vue?vue&type=template&id=800adab0&scoped=true&"
import script from "./PortalInvitationPopup.vue?vue&type=script&lang=ts&"
export * from "./PortalInvitationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PortalInvitationPopup.vue?vue&type=style&index=0&id=800adab0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800adab0",
  null
  
)

export default component.exports